import PrintOrderOptions from "emun.order/order-print";
import orderConfig from "emun.order/order.config";
import "emun.order/picker/order-picker-cards.htm";
import "emun.order/picker/order-picker-table.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";

export const dateRanges = [
  {
    id: "All",
    title: "All",
  },
  {
    id: "Today",
    title: "Today",
  },
  {
    id: "WTD",
    title: "Week to Date",
  },
  {
    id: "LW",
    title: "Last Week",
  },
  {
    id: "MTD",
    title: "Month to Date",
  },
  {
    id: "LM",
    title: "Last Month",
  },
  {
    id: "Last30",
    title: "Last 30 Days",
  },
  {
    id: "QTD",
    title: "Quarter to Date",
  },
  {
    id: "YTD",
    title: "Year to Date",
  },
  {
    id: "Last365",
    title: "Last 12 Months",
  },
];

export const views = {
  table: "table",
  //  cards: "th-large"
};

export const sortOptions = {
  Id: "Order #: High to Low",
  "-Id": "Order #: Low to High",
  "Status,-Id": "Status: A to Z",
  "-Status,-Id": "Status: Z to A",
  "PurchaseOrder,-Id": "PO #: High to Low",
  "-PurchaseOrder,-Id": "PO #: Low to High",
  "VendorLabel,-Id": "Vendor: A to Z",
  "-VendorLabel,-Id": "Vendor: Z to A",
  "CompanyName,-Id": "Customer: A to Z",
  "-CompanyName,-Id": "Customer: Z to A",
  "OrderedOn,-Id": "Order Date: Newest",
  "-OrderedOn,-Id": "Order Date: Oldest",
  "ShipOn,-Id": "Ship Date: Newest",
  "-ShipOn,-Id": "Ship Date: Oldest",
  "GrandTotal,-Id": "Amount: High to Low",
  "-GrandTotal,-Id": "Amount: Low to High"
};

export default class OrderPickerController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.setOrderIds();
    $ctrl.query = new AutoQuery($ctrl.getOrdersQueryOptions());
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.orderConfig = orderConfig;
    //$ctrl.viewSelectionsChanged(); //load()
  }

  templateUrl = () => `order-picker-${this.query.view}.htm`;

  selectAll() {
    const $ctrl = this;
    $ctrl.query.results.forEach((p) => ($ctrl.selected[p.id] = true));
    this.setOrderIds();
  }
  clearAll() {
    this.selected = {};
    this.setOrderIds();
  }
  canClear() {
    return Object.keys(this.selected).length;
  }

  isSelected(order) {
    return !!this.selected[order.id];
  }

  setOrderIds() {
    this.orderIds = Object.keys(this.selected || {});
  }

  selectionsLabel() {
    const { orderIds: keys = [] } = this;
    if (keys.length > 4)
      return `Selected: ${keys.slice(0, 4).join(", ")} and ${
        keys.length - 4
      } more...`;
    if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
    return "No selections";
  }

  hasSelections = () => Object.keys(this.selected).length > 0;

  viewSelectionsChanged() {
    const $ctrl = this;
    const idIn = $ctrl.viewSelections
      ? Object.keys($ctrl.selected || {}).join(",")
      : null;
    $ctrl.query.clearRefinements(false);
    $ctrl.query.filter("IdIn", idIn);
  }

  toggle(order) {
    const $ctrl = this;
    console.log("toggle", order.id, $ctrl.selected, order);

    if ($ctrl.single) {
      $ctrl.$close(order);
    } else if (order.id in $ctrl.selected) {
      delete $ctrl.selected[order.id];
      $ctrl.onOrderUnSelected &&
        $ctrl.onOrderUnSelected({ $order: order, ...$ctrl });
    } else {
      $ctrl.selected[order.id] = true;
      $ctrl.onOrderSelected &&
        $ctrl.onOrderSelected({ $order: order, ...$ctrl });
    }
    this.setOrderIds();
  }
  select(order) {
    const $ctrl = this;
    $ctrl.$close([order]);
  }

  $onDestroy() {
    this.query.dispose();
  }

  printOrder() {
    const $ctrl = this;
    return PrintOrderOptions({
      request: {
        id: $ctrl.orderIds.join(","),
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }
  resume() {
    const $ctrl = this;
    $ctrl.bus
      .read("QueryCarts.json", {
        IdIn: $ctrl.orderIds,
      })
      .then(function (response) {
        $ctrl.$cart.addOrderToSession(...response.data.results);
        $ctrl.$close();
        $ctrl.$state.transitionTo(
          $ctrl.$cart.orderConfig.defaultDetailRoute || "orders.detail",
          {
            orderId: response.data.results[0].id,
          }
        );
      });
  }
  exportLines(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        "&output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strOrderNumber=" +
        $ctrl.orderIds.join(",")
    );

    console.info("Exporting order lines to: ", url);
    return (location.href = url);
  }

  deleteOrder() {
    const $ctrl = this;
    let request = {
      OrderIds: $ctrl.orderIds.join(","),
    };
    return modals
      .confirm(
        "Delete the selected order(s)?  Warning: All selected orders will be made inactive.  To undo this go to View Inactive Orders.",
        "Delete Order"
      )
      .result.then(function () {
        $ctrl.bus.send("DeleteOrders.json", request).then(function () {
          $ctrl.query.load();
        });
      });
  }

  getOrdersQueryOptions() {
    const $ctrl = this;
    var filters = [];
    orderConfig.filters.forEach(function (obj) {
      filters.push(obj);
    });
    return {
      url: `QueryCartsJoin.json`, //?StatusNotEqualTo=Cart',
      tagTotalsUrl: `QueryCartsJoin.json`,
      orderBy: "-OrderedOn,-Id",
      disableQueryString: !!$ctrl.disableQueryString,
      pageSize: 12,
      criteria: $ctrl.criteria,
      views,
      view: $ctrl.view || $ctrl.$pageConfig.is("gt-md") ? "table" : "cards",
      filters,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions,
    };
  }
}
